// Generated by ReScript, PLEASE EDIT WITH CARE


function importCss(param) {
  return (require(`CrmGenericComponentsAssets/styles/_crm-generic-cmp-main.scss`));
}

function getImage(name) {
  var requireImage = (function(name){
        return require(`CrmGenericComponentsAssets/images/${name}`).default
      });
  return requireImage(name);
}

export {
  importCss ,
  getImage ,
  
}
/* No side effect */
